import { createFileRoute } from "@tanstack/react-router";
import { Navbar, Footer } from "@/components/hilltop";
import { Faculty } from "@/components/hilltop/Faculty";

export const Route = createFileRoute("/_public/faculty")({
  component: FacultyPage,
});

function FacultyPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Faculty />
      <Footer />
    </div>
  );
}
